import { motion } from "framer-motion";
import { Search } from "lucide-react";

const TENANTS_IMG = "https://images.unsplash.com/photo-1769740333462-9a63bfa914bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBtZWV0aW5nJTIwcm9vbXxlbnwwfHx8fDE3NzY3MzYzMDR8MA&ixlib=rb-4.1.0&q=85";

export const Tenants = ({ onOpenEncontrar }) => {
  return (
    <section
      id="empresas"
      className="relative py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="tenants-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
            className="relative"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img src={TENANTS_IMG} alt="Reunião corporativa" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-[#D4B366]/50 -z-10" />
            <div className="absolute -top-6 -left-6 w-24 h-24 border-t border-l border-[#D4B366]" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="gold-divider" />
              <span className="eyebrow">Para Empresas</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#F5F1EA] mb-8" data-testid="tenants-title">
              Procurando o <span className="italic gold-text">espaço ideal</span> para sua empresa?
            </h2>
            <div className="space-y-5 text-[#A2AAC2] text-base md:text-[1rem] leading-[1.85] font-light mb-10 max-w-lg">
              <p>
                O imóvel certo impacta diretamente na operação, na experiência do cliente e no
                crescimento do negócio.
              </p>
              <p>
                Seja para instalar sua loja, escritório, operação logística ou estrutura
                corporativa, ajudamos você a encontrar um imóvel alinhado à realidade e ao objetivo
                da sua empresa.
              </p>
            </div>

            <button
              onClick={onOpenEncontrar}
              className="btn-gold group"
              data-testid="tenants-encontrar-btn"
            >
              <Search size={16} strokeWidth={1.5} />
              Encontrar Imóvel
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
